import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie';

declare let jQuery: any;

@Component({
  selector: 'app-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss']
})
export class RadioButtonComponent implements OnInit, AfterViewInit {

  @ViewChild('validationForm') validationForm: any;

  @Input() formItem: any;
  @Input() invalidForm: any;
  @Input() formId:any;

  @Output() callUpdate = new EventEmitter();
  @Output() invalidFormChange = new EventEmitter<boolean>();

  radioOptions: any;
  formTitle: string;
  isRequired: string;
  renderType: boolean;
  classRbtn: string;
  modelThermometer: number = 5;
  maxSteps: number = 10;
  maskWidth: number = 0;
  imageLength: number = 655;
  widthThermometer: number = 0;
  styleImageThermometer: JSON;
  label1: string;
  label10: string;
  marginLabel: number = 0;
  languageId: number = 1;
  itemValue:string;

  sliderConfig: any = {
    connect: true,
    behaviour: 'drag',
    range: {
      min: 0,
      max: 10
    },
    step: 1,
    orientation: 'horizontal'
  };

  sliderConfigMobile: any = {
      connect: true,
      behaviour: 'drag',
      range: {
        min: 0,
        max: 10
      },
      step: 1,
      orientation: 'horizontal',
      pips: {
        mode: 'steps',
        density: 7,
      }
    };

  constructor(private cookieService: CookieService
  ) { }

  get valueThermometer(): number {
    return Number(this.formItem.value);
  }


  set valueThermometer(value: number) {
    this.formItem.value = value;
  }

  /*get getStyleImageThermometer(): String {
    return (JSON.parse(this.styleImageThermometer));
  }*/

  ngOnInit() {
    // Delete parent BoolValue
    delete this.formItem.boolValue;
    this.itemValue=this.formItem.value;
    this.isRequired = this.formItem.item.isRequired;
    this.renderType = this.formItem.item.renderType === 1 ? true : false;
    this.radioOptions = this.formItem.item.datasource.datasourcesItems;
    this.label1 = this.formItem.item.label1;
    this.label10 = this.formItem.item.label10;

    let lg = 6;
    if (this.radioOptions.length == 3 || this.radioOptions.length == 4) {
      lg = 3;
    }
    else if (this.radioOptions.length > 4) {
      lg = 2;
    }

    this.classRbtn = "col-xs-12 col-sm-6 col-lg-" + lg + " option-wrapper optionsDiv";
    this.languageId = Number(this.cookieService.get('formLanguage'));
  }

  getLabelFormTitle() {
    try {
      let optionFound = this.formItem.item.itemLabels.filter(x => x.language !== null && x.language !== undefined && x.language.idLanguage === this.languageId)[0];
      if (optionFound?.labelField && optionFound.labelField !== '')
        return optionFound.labelField;
      else {
        return this.formItem.item.itemLabels[0].labelField;
      }
    }
    catch (Exception) {
      return '';
    }
  }

  updateConditional() {
    this.updateMaskLength();
    if (this.formItem.item.isConditional) {
      this.callUpdate.emit();
    }
  }

  deleteBoolValue(option: any) {
    delete this.formItem.boolValue;
  }

  // Use this cycle because the view has to render the conditionals
  // The HTML <template> (or ng-container) element is a mechanism for holding client-side content
  // that is not to be rendered when a page is loaded but may subsequently be instantiated
  // during runtime using JavaScript.
  ngAfterViewInit() {
    if (this.isRequired) {
      this.validationForm.control.statusChanges.subscribe(() => {
        this.invalidFormChange.emit(this.validationForm.invalid);
      });
    }
  }

 updateMaskLength() {
    // While sliding, update the value in the #thermometer-label element
   let screenWidth=window.innerWidth;
    if (this.valueThermometer === this.maxSteps) {
      /*
        Max steps
       */

      if(screenWidth>=1250){
        this.widthThermometer = this.imageLength;
        this.marginLabel = this.widthThermometer - 119;
      }
      else if(screenWidth>=700 && screenWidth<800){

        this.widthThermometer = this.imageLength;
        this.marginLabel = 250;
      }
      else if(screenWidth>=800 && screenWidth<1024){
        this.widthThermometer = this.imageLength+20;
        this.marginLabel = 400;
      }
      else if(screenWidth>=1024 && screenWidth<1250){
        this.widthThermometer = this.imageLength;
        this.marginLabel = 385;
      }

    } else if (this.valueThermometer === 0) {

      /*
      Min steps
       */

      if(screenWidth>=1250){
        this.widthThermometer = 154;
        this.marginLabel = 100;
      }
      else if(screenWidth>=700 && screenWidth<800){

        this.widthThermometer = 150;
        this.marginLabel = 350;
      }
      else if(screenWidth>=800 && screenWidth<1024){
        this.widthThermometer = 140;
        this.marginLabel = 380;
      }
      else if(screenWidth>=1024 && screenWidth<1250){
        this.widthThermometer = 114;
        this.marginLabel = 139;
      }


    } else {

      /*
      Steps between 1 and 9
       */


      if(screenWidth>=1250){
        this.widthThermometer = 154 + 418 * this.valueThermometer / this.maxSteps;
        this.marginLabel = this.widthThermometer - 16;
      }
      else if(screenWidth>=700 && screenWidth<800){

        this.widthThermometer =  140 + 440 * this.valueThermometer / this.maxSteps;
        this.marginLabel = 350 ;
      }
      else if(screenWidth>=800 && screenWidth<850){
        this.widthThermometer =  120 + 350 * this.valueThermometer / this.maxSteps;
        this.marginLabel = 450 ;
      }
      else if(screenWidth>=850 && screenWidth<900){
        this.widthThermometer =  150 + 375 * this.valueThermometer / this.maxSteps;
        this.marginLabel = 450 ;
      }
      else if(screenWidth>=900 && screenWidth<1000){
        this.widthThermometer =  150 + 425 * this.valueThermometer / this.maxSteps;
        this.marginLabel = 385 ;
      }
      else if(screenWidth>=1000 && screenWidth<1100){
        this.widthThermometer =  150 + 435 * this.valueThermometer / this.maxSteps;
        this.marginLabel = 385 ;
      }
      else if(screenWidth>=1100 && screenWidth<1250){
        this.widthThermometer =  150 + 443 * this.valueThermometer / this.maxSteps;
        this.marginLabel = 385 ;
      }




    }
  }


  getLabel(option) {
    try {
      if (option?.datasourceItemsLabels && option.datasourceItemsLabels.length > 0) {
        let optionFound = option.datasourceItemsLabels.filter(x => x.language !== null && x.language !== undefined && x.language.idLanguage === this.languageId)[0];
        if (optionFound?.labelField && optionFound.labelField !== '')
          return optionFound.labelField;
        else {
          return option.datasourceItemsLabels[0].labelField;
        }
      }
      else
        return '';
    }
    catch (Exception) {
      return '';
    }
  }




}
